exports = module.exports = require("./../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.lxm-cf-project-feedback__summary-number[data-v-20e5b073] {\n  color: #ff5348;\n  font-size: 1.07rem;\n}\n", "", {"version":3,"sources":["/./src/components/Main/Cf/Project/src/components/Main/Cf/Project/Feedback.vue","/./src/components/Main/Cf/Project/Feedback.vue"],"names":[],"mappings":";AAkBA;EACE,eAAA;EACA,mBAAA;CCjBD","file":"Feedback.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n@import '../../../styles/index.styl'\n.lxm-cf-project-feedback__summary-number\n  color: brand-primary\n  font-size: size-big\n",".lxm-cf-project-feedback__summary-number {\n  color: #ff5348;\n  font-size: 1.07rem;\n}\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=data-v-20e5b073&scoped=true!./~/stylus-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Main/Cf/Project/Feedback.vue
// module id = 607
// module chunks = 0